import React, { Fragment, useContext, useState, useCallback } from "react";
import { UserContext } from "UserContext";
import { Grid, makeStyles } from "@material-ui/core";
import { fetchReport, saveReportResponse } from "fetchUtils";
import ReportsCard from "./ReportsCard";
import OrganizationReportsPickerCard from "./OrganizationReportsPickerCard";
import LoadingButton from "./LoadingButton";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const getSessionReportUrl = props =>
  `${
    process.env.REACT_APP_API_BASE_URL
  }/reports/platform/session/report.csv?org-id=${
    props.selectedOrganization
  }&start=${isoDate(props.startDate)}&end=${isoDate(props.endDate)}`;

const minReportDate = new Date("2016-01-01");

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.secondary.light,
    height: "100%",
    overflowX: "hidden",
  },
  exportButton: {
    width: 120,
    height: 40,
    marginBottom: 15,
    float: "right",
    right: 15,
  },
  radioGroup: {
    justifyContent: "space-around",
    marginBottom: 15,
  },
  reportDetailsCard: {
    position: "relative",
    // height: 321,
  },
  dateColumn: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  dateSelect: {
    marginTop: 25,
    marginBottom: 25,
  },
  datePicker: {
    minWidth: 130,
    width: "100%",
  },
}));

const initialState = {
  showLoading: false,
  selectedOrganization: "",
  startDate: new Date(),
  endDate: new Date(),
};

const isoDate = date => date.toISOString().substr(0, 10);

const SessionReports = () => {
  const classes = useStyles();
  const { token, user } = useContext(UserContext);
  const [state, setState] = useState(initialState);

  const handleStateChange = name => value => {
    setState(s => ({ ...s, [name]: value }));
  };

  const handleSelectedOrganization = useCallback(value => {
    handleStateChange("selectedOrganization")(value);
  }, []);

  const exportReport = props => {
    handleStateChange("showLoading")(true);

    const url = getSessionReportUrl(props);

    fetchReport(url, props.token)
      .then(response =>
        saveReportResponse(response, "platform-session-report.csv")
      )
      .finally(() => handleStateChange("showLoading")(false));
  };

  return (
    <Fragment>
      <Grid item xs>
        <OrganizationReportsPickerCard
          organizations={user.organizations}
          onOrganizationChange={handleSelectedOrganization}
        ></OrganizationReportsPickerCard>
      </Grid>

      {state.selectedOrganization && (
        <Grid item xs>
          <ReportsCard
            cardLabel="Report Details"
            className={classes.reportDetailsCard}
          >
            <Grid container direction="column" className={classes.dateColumn}>
              <Grid
                container
                item
                direction="row"
                alignItems="flex-end"
                spacing={1}
                className={classes.dateSelect}
              >
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid item xs>
                    <KeyboardDatePicker
                      className={classes.datePicker}
                      margin="normal"
                      id="startDate"
                      label="Start Date"
                      format="MM/dd/yyyy"
                      disableFuture={true}
                      minDate={minReportDate}
                      value={state.startDate}
                      onChange={handleStateChange("startDate")}
                      KeyboardButtonProps={{
                        "aria-label": "start date",
                      }}
                    />
                  </Grid>

                  <Grid item xs>
                    <KeyboardDatePicker
                      className={classes.datePicker}
                      margin="normal"
                      id="endDate"
                      label="End Date"
                      format="MM/dd/yyyy"
                      disableFuture={true}
                      minDate={minReportDate}
                      value={state.endDate}
                      onChange={handleStateChange("endDate")}
                      KeyboardButtonProps={{
                        "aria-label": "end date",
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item align="right">
                <LoadingButton
                  variant="contained"
                  disableElevation
                  className={classes.exportButton}
                  onClick={() => exportReport({ token, ...state })}
                  disabled={state.disableExport}
                  showLoading={state.showLoading}
                >
                  EXPORT
                </LoadingButton>
              </Grid>
            </Grid>
          </ReportsCard>
        </Grid>
      )}
    </Fragment>
  );
};

export default SessionReports;
